<template>
  <div>
    <van-pull-refresh
      v-model="showPullRefreshLoading"
      @refresh="
        () => {
          showPullRefreshLoading = false;
          toQueryAccountInformation();
          $refs.refSpecialCouponBtn.toQuerySpecialRote();
        }
      "
    >
      <div class="charing-center-page">
        <div class="charing-center-page-bg" />
        <div style="position: relative; z-index: 2">
          <div class="charing-center-page-header">
            <div class="account-wrap">
              <div class="account-wrap-title">充值账号</div>
              <div
                class="account-wrap-account"
                @click="handleAccountClick"
              >
                <span v-if="form.chargePhone">{{
                  formatPhone(form.chargePhone)
                }}</span>
                <span
                  class="account-value-tips"
                  v-else
                >请输入手机号</span>
                <img
                  class="account-wrap-icon"
                  src="@/assets/img/chargingVoucher/icon-edit.png"
                >
              </div>
            </div>
          </div>
          <div class="buy-coupon">
            <div class="coupon-title">充电服务商</div>
            <div class="coupon-provider-tabs">
              <div
                v-for="item in provideTabOptions"
                :key="item.key"
                class="coupon-provider-tab"
                :class="{
                  active: item.key === curProviderTab.key,
                }"
                @click="handleProviderTabClick(item)"
              >
                <img
                  class="coupon-provider-tab-icon"
                  :src="item.icon"
                >
                <span>{{ item.text }}</span>
              </div>
            </div>

            <div class="coupon-title">充电券类型</div>
            <div class="coupon-type-tabs">
              <div
                v-for="item in curProviderTab.chargeCouponTypeOptions"
                :key="item.key"
                class="coupon-type-tab"
                :class="{
                  active: item.key === curChargeCouponTypeTab,
                }"
                @click="handleChargeCouponTypeTabClick(item)"
              >
                <span>{{ item.value }}</span>
              </div>
            </div>

            <div class="coupon-title">充电券面额</div>
            <div class="buy-coupon-list">
              <div
                v-for="item in coupons"
                :key="item.id"
                class="buy-coupon-item"
                :class="{
                  active: item.couponConfigCode === form.couponConfigCode,
                  disabled: !item.quantity || item.quantity === 0,
                }"
                @click="() => handleCouponClick(item)"
              >
                <div
                  class="buy-coupon-discount"
                  :class="{
                    preference: item.isQuota == '1',
                  }"
                  v-if="item.discount"
                >
                  {{ `${item.isQuota == "1" ? "特惠" : ""}${item.discount}` }}折
                </div>
                <div class="buy-coupon-value">
                  {{ item.productAmountYuan }}元
                </div>
                <div class="buy-coupon-price">
                  售价{{ item.discountAmountYuan }}元
                </div>
                <div class="buy-coupon-price-remark">
                  {{ item.remark }}
                </div>
                <div class="buy-coupon-stock">
                  剩余：{{ item.quantity || 0 }}张
                </div>
              </div>
              <div
                v-if="!coupons.length"
                class="blank-tips"
              >
                补充中，请稍候
              </div>
            </div>
            <div class="buy-coupon-number-wrap">
              <div class="buy-coupon-number-wrap-title">购买数量</div>
              <NumberInput
                :value="form.buyNum"
                :min="1"
                @left="() => (form.buyNum = Number(form.buyNum) - 1)"
                @right="() => (form.buyNum = Number(form.buyNum) + 1)"
                @middle="handleNumberInputMiddleClick"
              />
            </div>
          </div>
        </div>
        <div class="h-210" />
        <div
          v-if="$parent.showBottomNavBar"
          class="h-bottom-nav"
        />
      </div>
    </van-pull-refresh>

    <div class="bottom-btn-wrap">
      <div
        v-if="isAuthorize && haveWaitPayOrder"
        class="wait-pay-btn"
        @click="handleWaitPayBtnClick"
      >
        您有一笔待支付订单
      </div>
      <div class="coupon-provider-tips">
        <p>
          温馨提示：抵扣券有效期1个月，购买后不可退款和转让，过期自动作废，请根据需求购买。
        </p>
        <span
          class="link-text"
          @click="showCouponTips()"
        >更多说明</span>
      </div>
      <div
        class="buy-btn-wrap"
        v-if="isAuthorize"
      >
        <div class="buy-btn-value">
          <p>
            合计支付：
            <span>
              ￥ <i>{{ totalAmount }}</i>元
              <template v-if="canUseScore">
                或 <i>{{ totalScore }}</i>积分
              </template>
            </span>
          </p>
          <p>
            已优惠：<span>￥{{ discountAmountValue }}元</span>
          </p>
        </div>
        <div
          class="buy-btn"
          @click="handleBuyBtnClick"
        >立即支付</div>
      </div>
      <div
        v-if="$parent.showBottomNavBar"
        class="h-bottom-nav"
      />
    </div>

    <!-- 用户授权弹窗 -->
    <UserAuthPopup
      ref="refUserAuthPopup"
      @confirm="toSaveAccountInformation"
      @cancel="handleUserAuthCancel"
    />
    <!-- 待支付订单弹窗 -->
    <WaitPayPopup
      ref="refWaitPayPopup"
      :value="waitPayOrderInfo"
      @close="toQueryUnPaidChargeCouponOrder"
      @confirm="handleWaitPayConfirm"
      @cancel="handleWaitPayCancel"
    />
    <!-- 支付确认弹窗 -->
    <PayCheckPopup
      ref="refPayCheckPopup"
      :charge-number="form.chargePhone"
      :provider-name="curProviderTab.desc"
      @confirm="handlePayCheckPopupConfirm"
      @cancel="handlePayCheckPopupCancel"
    />
    <!-- 支付结果弹窗 -->
    <PayResultPopup
      ref="refPayResultPopup"
      @confirm="toMyCouponsPage"
    />
    <!-- 输入弹窗 -->
    <InputPopup
      ref="refInputPopup"
      :min="1"
      @confirm="handleInputPopupConfirm"
    />
    <!-- 用券提示弹窗 -->
    <TipsBottomPopup ref="refTipsBottomPopup" />
    <!-- 提示弹窗 -->
    <TipsPopup
      ref="refTipsPopup"
      @confirm="(fn) => fn()"
      @close="toQueryUnPaidChargeCouponOrder"
    />
    <!-- 支付方式弹窗 -->
    <PayTypePopup
      ref="refPayTypePopup"
      :can-use-score="canUseScore"
      :pay-value="totalAmount"
      :pay-score="totalScore"
      @confirm="beforeToPrePay"
    />
    <!-- 特惠券包悬浮按钮 -->
    <SpecialCouponBtn
      ref="refSpecialCouponBtn"
      v-if="isAuthorize"
      agency-code="01c5123cff66c930c16d737cef6da57a7a2c927866808697037a63a5f9e85fd4"
    />
  </div>
</template>

<script>
import UserAuthPopup from './UserAuthPopup.vue';
import WaitPayPopup from './WaitPayPopup.vue';
import PayCheckPopup from './PayCheckPopup.vue';
import PayResultPopup from './PayResultPopup.vue';
import InputPopup from './InputPopup.vue';
import IconXJCD from '@/assets/img/chargingVoucher/logo-xjcd.png';
import IconTLD from '@/assets/img/chargingVoucher/logo-tld.png';
import IconXXCD from '@/assets/img/chargingVoucher/logo-xxcd.png';
import {
  createChargeCouponOrder,
  queryChargeCouponList,
  queryUnPaidChargeCouponOrder,
  cancelChargeCouponOrder,
  prePayChargeCouponOrder,
  queryAccountInformation,
  saveAccountInformation,
  queryChargeCouponDetail,
  queryCustomerScore
} from '@/common/api.js';
import Pay from '@/common/weixin.js';
import NumberInput from './NumberInput.vue';
import TipsBottomPopup from './TipsBottomPopup.vue';
import TipsPopup from './TipsPopup.vue';
import PayTypePopup from './PayTypePopup.vue';
import { REGEX_PHONE } from '@/common/regex';
import SpecialCouponBtn from './SpecialCouponBtn.vue';

class CreateForm {
  orderPhone = ''; // 下单账号手机
  chargePhone = ''; // 充值账号手机
  couponConfigCode = ''; // 充电券配置券Code
  buyNum = 1; // 购买数量
  payAmountYuan = 0; // 支付金额（单位：元）
}

export default {
  name: 'CharingCenter',
  components: {
    UserAuthPopup,
    WaitPayPopup,
    PayCheckPopup,
    PayResultPopup,
    InputPopup,
    NumberInput,
    TipsBottomPopup,
    TipsPopup,
    PayTypePopup,
    SpecialCouponBtn
  },
  data() {
    const provideTabOptions = [
      {
        text: '星星',
        desc: '星星充电',
        key: 'STARCHARGE',
        icon: IconXXCD,
        chargeCouponTypeOptions: [
          {
            id: 356838,
            key: 'SERVICE_OFF',
            name: '充电券类型',
            value: '服务费抵扣券'
          },
          {
            id: 356839,
            key: 'PAY_OFF',
            name: '充电券类型',
            value: '服务费+电费通抵券'
          }
        ]
      },
      {
        text: '特来电',
        desc: '特来电',
        key: 'TELD',
        icon: IconTLD,
        chargeCouponTypeOptions: [
          {
            id: 356838,
            key: 'SERVICE_OFF',
            name: '充电券类型',
            value: '服务费抵扣券'
          },
          {
            id: 356839,
            key: 'PAY_OFF',
            name: '充电券类型',
            value: '服务费+电费通抵券'
          }
        ]
      },
      {
        text: '小桔',
        desc: '小桔充电',
        key: 'XIAOJU',
        icon: IconXJCD,
        chargeCouponTypeOptions: [
          {
            id: 356839,
            key: 'PAY_OFF',
            name: '充电券类型',
            value: '服务费+电费通抵券'
          }
        ]
      }
    ];

    return {
      // 供应商列表
      provideTabOptions,
      // 当前供应商
      curProviderTab: provideTabOptions[0],
      // 充电券列表
      rightCouponConfigList: {},
      // 表单
      form: new CreateForm(),
      // 已选择的充电券
      selectedCoupon: {},
      // 未支付订单信息
      waitPayOrderInfo: {},
      // 订单号
      orderNo: '',
      // 用户信息
      userInfo: {},
      // 是否同意用户授权协议
      authorize: '0',
      // 是否显示下拉刷新
      showPullRefreshLoading: false,
      // 充电券类型
      curChargeCouponTypeTab: 'SERVICE_OFF',
      // 可使用积分
      canUseScore: 0,
      // 支付方式
      chargePayType: 'WECHAT_PAY' // WECHAT_PAY 微信支付， SCORE_PAY 积分支付
    };
  },
  computed: {
    coupons() {
      let arr = [];
      try {
        arr = this.rightCouponConfigList[this.curProviderTab.key] || [];
      } catch (error) {
        arr = [];
      }
      return arr?.filter(
        (item) => item.chargeCouponType === this.curChargeCouponTypeTab
      );
    },
    totalAmount() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedCoupon.discountAmountYuan || 0
          ).toFixed(2)
        ) || 0
      );
    },
    totalScore() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedCoupon.payScore || 0
          ).toFixed(2)
        ) || 0
      );
    },
    discountAmountValue() {
      return (
        Number(
          (
            this.form.buyNum * this.selectedCoupon.productAmountYuan -
            this.form.buyNum * this.selectedCoupon.discountAmountYuan || 0
          ).toFixed(2)
        ) || 0
      );
    },
    isAuthorize() {
      return this.authorize == '1';
    },
    haveWaitPayOrder() {
      return !!this.waitPayOrderInfo.orderNo;
    },
    coupontype() {
      return `${this.curProviderTab.key || ''}_${
        this.curChargeCouponTypeTab || ''
      }`;
    }
  },
  watch: {
    coupons: {
      handler(val) {
        val.forEach((item) => {
          if (item.couponConfigCode === this.form.couponConfigCode) {
            this.selectedCoupon.productAmountYuan = item.productAmountYuan;
            this.selectedCoupon.discountAmountYuan = item.discountAmountYuan;
          }
        });
      },
      immediate: true
    }
  },
  created() {
    this.form.couponConfigCode = '';
    this.selectedCoupon = {};
    this.toQueryAccountInformation();
    this.toQueryCustomerScore();
  },
  mounted() {
    let isCallBack = localStorage.getItem('_isCallBack') || '';
    let orderNo = localStorage.getItem('_orderNo') || '';
    if (isCallBack === 'undefined') {
      isCallBack = null;
      localStorage.removeItem('_isCallBack');
    }
    if (orderNo === 'undefined') {
      orderNo = null;
      localStorage.removeItem('_orderNo');
    }

    if (isCallBack && orderNo) {
      this.checkPay(orderNo);
    }
  },
  methods: {
    // 查询是否授权
    toQueryAccountInformation() {
      const param = {};
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      queryAccountInformation(param).then((res) => {
        if (res) {
          this.authorize = res.authorize;
          if (res.authorize == '0') {
            this.$refs.refUserAuthPopup.openPopup();
          } else {
            this.toQueryChargeCouponList();
            this.toQueryUnPaidChargeCouponOrder();
          }
        }
        this.$toast.clear();
      });
    },
    // 保存授权信息
    toSaveAccountInformation() {
      const param = {
        aseUserId: localStorage.getItem('_aseUserId') || '',
        authorize: '1'
      };
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true,
        duration: 0
      });
      saveAccountInformation(param).then((res) => {
        this.authorize = '1';
        this.toQueryChargeCouponList();
        this.handleUserAuthCancel();
        this.$toast.clear();
      });
    },
    handleUserAuthCancel() {
      this.$refs.refUserAuthPopup.closePopup();
    },
    // 查询充电券列表
    toQueryChargeCouponList() {
      const param = {};
      queryChargeCouponList(param).then((res) => {
        if (res) {
          this.form.orderPhone = res.phone || '';
          localStorage.setItem('_phone', res.phone);
          if (!this.form.chargePhone) {
            this.form.chargePhone =
              localStorage.getItem('_chargePhone') || res.phone || '';
          }
          localStorage.setItem('_chargePhone', this.form.chargePhone);
          this.rightCouponConfigList = res.rightCouponConfigList;
        }
      });
    },
    // 选择供应商
    handleProviderTabClick(item) {
      this.curProviderTab = item;
      if (item.key === 'STARCHARGE') {
        this.curChargeCouponTypeTab = 'SERVICE_OFF';
        // this.$toast('服务商正在对接中,敬请期待');
        // return;
      }
      if (item.key === 'XIAOJU') {
        this.curChargeCouponTypeTab = 'PAY_OFF';
      }
      if (item.key === 'TELD') {
        this.curChargeCouponTypeTab = 'SERVICE_OFF';
      }

      this.form.couponConfigCode = '';
      this.selectedCoupon = {};
      this.toQueryChargeCouponList();
    },
    // 选择充电券类型
    handleChargeCouponTypeTabClick(item) {
      this.curChargeCouponTypeTab = item.key;
      this.form.couponConfigCode = '';
      this.selectedCoupon = {};
      this.toQueryChargeCouponList();
    },
    // 选择充电券
    handleCouponClick(item) {
      // 2024.08.27 小桔充电券不可选中
      if (this.curProviderTab.key === 'XIAOJU') {
        this.$toast('该充电券升级维护中，敬请期待');
        return;
      }

      if (!item.quantity || item.quantity === 0) {
        this.$toast('该券已售罄，将在1天内补充，敬请期待');
        return;
      } else {
        if (this.form.couponConfigCode === item.couponConfigCode) {
          this.form.couponConfigCode = '';
          this.selectedCoupon = {};
        } else {
          this.selectedCoupon = item;
          this.form.couponConfigCode = item.couponConfigCode;
        }
      }
    },
    // 展示提醒弹窗
    showCouponTips() {
      this.$refs.refTipsBottomPopup.openPopup({
        type: this.coupontype
      });
    },
    // 下单
    handleBuyBtnClick() {
      if (this.haveWaitPayOrder) {
        this.$refs.refTipsPopup.openPopup({
          text: '您有一笔订单暂未支付，请处理完毕后再支付新的订单。'
        });
        return;
      }
      if (!this.form.chargePhone) {
        this.$toast('请输入充值账号');
        return;
      }
      if (!REGEX_PHONE.test(this.form.chargePhone)) {
        this.$toast('充值账号应为有效手机号');
        return;
      }
      if (!this.form.couponConfigCode) {
        this.$toast('请选择充电券');
        return;
      }
      if (this.form.buyNum > this.selectedCoupon.quantity) {
        this.$toast('购买数量不能大于剩余数量');
        return;
      }
      if (this.selectedCoupon.isPrompt == 1) {
        this.$refs.refTipsPopup.openPopup({
          showCancelBtn: true,
          cancelBtnText: '重新选择',
          confirmBtnText: '确认购买',
          text: this.selectedCoupon.promptContent || '',
          confirm: () => {
            this.$refs.refPayCheckPopup.openPopup();
          }
        });
        return;
      }

      // 兼容旧有逻辑
      if (!this.form.orderPhone) {
        this.form.orderPhone = this.form.chargePhone;
      }
      this.$refs.refPayCheckPopup.openPopup();
    },
    // 去支付前
    beforeToPrePay(payType) {
      this.chargePayType = payType;
      this.toPrePay();
      this.$refs.refPayTypePopup.closePopup();
    },
    // 预支付，创建订单
    toPrePay() {
      const param = {
        ...this.form,
        chargePayType: this.chargePayType,
        payAmountYuan: Number(this.totalAmount),
        payScore: Number(this.totalScore),
        chargeOrderModel: 'SINGLE_CLASS'
      };
      this.$toast.loading({
        message: '下单中...',
        forbidClick: true,
        duration: 0
      });
      createChargeCouponOrder(param, true)
        .then((res) => {
          if (res) {
            console.log('创建充电券订单成功');
            if (this.chargePayType === 'WECHAT_PAY') {
              this.toPay(res);
            } else {
              this.prePaySuccess();
            }
          }
          this.$toast.clear();
        })
        .catch((err) => {
          this.$toast.clear();
          const message = err?.data?.message || '';
          if (message.includes('购买数量上限')) {
            this.$refs.refTipsPopup.openPopup({
              text: message
            });
          } else {
            this.$toast(message);
          }
          this.toQueryUnPaidChargeCouponOrder();
        });
    },
    // 去支付
    toPay(res) {
      this.form.couponConfigCode = '';
      this.selectedCoupon = {};
      this.orderNo = res.orderNo;
      localStorage.setItem('_chargePhone', this.form.chargePhone);
      this.toPrePayChargeCouponOrder(res);
    },
    // 调用支付流程
    async toPrePayChargeCouponOrder(res) {
      const envMap = ['1', '1', '4'];
      // 调起预支付接口成功后
      try {
        this.$toast.loading({
          message: '支付中...',
          forbidClick: true,
          duration: 0
        });
        const prepayRs = await prePayChargeCouponOrder({
          payType: envMap[this.$browserEnv], // 支付环境
          orderNo: res.orderNo,
          openId: this.$route.query.openId || null,
          appCode: this.$route.query.appId || null
        });
        this.prePayHandle(prepayRs);
        this.$refs.refWaitPayPopup?.closePopup();
        this.$toast.clear();
      } catch (error) {
        console.log(error);
        this.toQueryUnPaidChargeCouponOrder();
      }
    },
    // 支付流程
    prePayHandle(payload) {
      const _payload = {
        appId: payload.appId,
        timeStamp: payload.timeStamp,
        nonceStr: payload.nonceStr,
        package: payload.packageValue,
        signType: payload.signType,
        paySign: payload.paySign,
        prepayId: payload.prepayId,
        mwebUrl: payload.mwebUrl
      };
      switch (this.$browserEnv) {
        case 0:
          Pay.mpPay(_payload, this.orderNo);
          break;
        case 1:
          Pay.wxPay(_payload, this.prePaySuccess, this.prePayFail);
          break;
        case 2:
          Pay.browserPay(_payload.mwebUrl, this.orderNo);
          break;
      }
    },
    // 支付成功
    prePaySuccess() {
      this.$refs.refPayResultPopup.openPopup(
        '充电券将在5分钟内发送到您的充值账户中，可前往目标充值账户中【我的充电券】页面查看购买的充电券。'
      );
      this.toQueryUnPaidChargeCouponOrder();
    },
    // 支付失败
    prePayFail() {
      this.$toast('支付失败');
      this.toQueryUnPaidChargeCouponOrder();
    },
    // 查询待支付订单
    toQueryUnPaidChargeCouponOrder() {
      const param = {
        chargeOrderModel: 'SINGLE_CLASS'
      };
      queryUnPaidChargeCouponOrder(param).then((res) => {
        this.waitPayOrderInfo = res || {};
        console.log(this.waitPayOrderInfo);
      });
    },
    // 打开待支付弹窗
    handleWaitPayBtnClick() {
      this.$refs.refWaitPayPopup.openPopup();
    },
    // 继续支付订单
    handleWaitPayConfirm() {
      wx.miniProgram.postMessage({
        data: {
          tips: '待支付订单刷新'
        }
      });

      if (this.chargePayType === 'WECHAT_PAY') {
        this.toPay(this.waitPayOrderInfo);
      } else {
        this.prePaySuccess();
      }
    },
    // 取消待支付订单
    handleWaitPayCancel() {
      const param = {
        orderNo: this.waitPayOrderInfo.orderNo
      };
      this.$toast.loading({
        message: '取消订单中...',
        forbidClick: true,
        duration: 0
      });
      cancelChargeCouponOrder(param).then((res) => {
        this.$toast('取消成功');
        this.toQueryChargeCouponList();
        this.$refs.refWaitPayPopup.closePopup();
      });
    },
    // 修改充值账号
    handleAccountClick() {
      const param = {
        key: 'chargePhone',
        inputType: 'tel',
        text: '充值账号',
        value: this.form.chargePhone
      };
      this.$refs.refInputPopup.openPopup(param);
    },
    // 弹出输入弹窗
    handleInputPopupConfirm(param) {
      this.$refs.refInputPopup.closePopup();
      this.form[param.key] = param.value;
    },
    // 修改购买数量
    handleNumberInputMiddleClick() {
      const param = {
        key: 'buyNum',
        inputType: 'number',
        text: '购买数量',
        value: this.form.buyNum
      };
      this.$refs.refInputPopup.openPopup(param);
    },
    // 格式化手机号
    formatPhone(val) {
      if (val) {
        const matches = /^(\d{3})(\d{4})(\d{4})$/.exec(val);
        if (matches) {
          return matches[1] + ' ' + matches[2] + ' ' + matches[3];
        }
        return val;
      }
    },
    // 检查支付结果
    async checkPay(orderNo) {
      const param = {
        orderNo: orderNo
      };
      this.$toast.loading({
        message: '支付结果检查中...',
        forbidClick: true,
        duration: 0
      });
      queryChargeCouponDetail(param).then((res) => {
        if (res.orderStatus == 'PAID_WAIT') {
          this.prePayFail();
        } else {
          this.prePaySuccess();
          this.$toast.clear();
        }
        localStorage.removeItem('_isCallBack');
        localStorage.removeItem('_orderNo');
      });
    },
    // 支付方式确定
    handlePayCheckPopupConfirm() {
      this.$refs.refPayCheckPopup.closePopup();
      this.$nextTick(() => {
        if (this.canUseScore) {
          this.$refs.refPayTypePopup.openPopup();
        } else {
          this.beforeToPrePay('WECHAT_PAY');
        }
      });
    },
    // 支付方式取消
    handlePayCheckPopupCancel() {
      this.$refs.refPayCheckPopup.closePopup();
      this.handleAccountClick();
    },
    toQueryCustomerScore() {
      const param = {};
      queryCustomerScore(param).then((res) => {
        if (res) {
          this.canUseScore = res.availableScore;
        }
      });
    },
    // 跳转我的充电券
    toMyCouponsPage() {
      if (this.$browserEnv == 0) {
        wx.miniProgram.switchTab({
          url: '/pages/chargingVoucher/my-coupons'
        });
      } else {
        this.$parent.handleNavBarClick('MyCoupons');
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../styles/CharingCenter.scss';

</style>
